@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="w-full mb-2 mt-4 px-2">
      <div class="leading-6 font-medium">{{ field.label | localize }}</div>
      @if (field.hint) {
        <div class="text-md text-secondary">{{ field.hint | localize }}</div>
      }
    </div>
  }
  <div class="flex flex-row flex-wrap items-center w-full border-b p-4 mb-4">
    @if (field?.dTypeForm) {
      <dtype-component-list class="w-full" [dtypeForm]="field.dTypeForm"
        [isUpdate]="isUpdate">
      </dtype-component-list>
    }
  </div>
}